export default {
  title: 'انتهت صلاحية عرض السعر',
  description:
    'معذرة، لقد انتهت صلاحية عروض الأسعار، رجاء الضغط هنا للحصول على عروض أسعار جديدة',
  confirmButton: 'الصفحة الرئيسية',
} as const
